import React from "react";
import { Card } from "../card";
import { AddBranch } from "./AddBranch";
import { ListBranch } from "./ListBranch/ListBranch";
import { GridWrapper } from "../GridWrapper/GridWrapper";

export const BranchesComponent = () => {
  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="Add branch">
              <div>
                <AddBranch />
              </div>
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="All branches">
              <ListBranch />
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
